module.exports = {
      id: "business-usage",
      viewBox: "0 0 28.79 24.369",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#business",
      toString: function () {
        return this.url;
      }
    }